var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-statics-staff',{attrs:{"isShowManage":false,"routeType":3,"title":"数据统计","exportCode":"7003"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }